import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { HashRouter as Router, Route } from 'react-router-dom';
import { i18nIntl, removeByRole, importCSS, getRemotedbUrl } from '../../lib/ep.js';
import { size as _size } from 'lodash';
import { sweep as const_sweep } from './bootstrap';

import { BackButton, MainButton, SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import Autocomplete from '../builder/Autocomplete'
import ButtonCollection from '../builder/ButtonCollection.js';
import BreadcrumbsNav from '../builder/BreadcrumbsNav';
import Checkbox from '../builder/Checkbox';
import { DeleteButton } from '../builder/ConfirmButton';
import DateTimePicker from '../builder/DateTimePicker';
import DisabledArea from '../builder/DisabledArea';
import FieldLabel from '../builder/FieldLabel';
import FloatingLayer from '../builder/FloatingLayer';
import HelpFeatureWarning from '../builder/HelpFeatureWarning';
import Input from '../builder/Input';
import LabelSelector from '../labels/LabelSelector';
import Message, { AlertMessage } from '../builder/Message';
import Model from '../builder/Model';
import ProgressBar from '../builder/ProgressBar';
import RadioGroup from '../builder/RadioGroup';
import SaveButton from '../builder/SaveButton';
import SaveResponseMessage from '../builder/SaveResponseMessage';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import Select from '../builder/Select';
import Spinner from '../builder/Spinner';
import StatsBarsH from '../builder/StatsBarsH';
import TextArea from '../builder/TextArea';
import ToggleButton from '../builder/ToggleButton';
import Tooltip from '../builder/Tooltip';

import InfiniteScroll from '../hoc/InfiniteScroll';

import UserName from '../front/UserName';

import DownloadFileOptions from '../backend/elements/DownloadFileOptions';
import BasicPlansComparisonTable from '../backend/BasicPlansComparisonTable';

import SweepParticipantsLayer from './SweepParticipantsLayer';
import SweepBlacklistSuggestLayer from './SweepBlacklistSuggestLayer';
import SweepSidebar from './SweepSidebar';
import Module, { ProfileModule } from '../ui_items/Module.js';
import OwnerPromoWrapper from '../ui_items/OwnerPromoWrapper.js';
import RibbonCollection from '../ui_items/RibbonCollection.js';
import SweepElasticStats from './SweepElasticStats.js';

const MessageFoo = ({ sweep, ...props }) => {
	if(props?.has_participants ?? false) return null;
	if(sweep.network != const_sweep.ID_FACEBOOK && sweep.network != const_sweep.ID_INSTAGRAM) return null;
	if(sweep.type == const_sweep.TYPE_STORY_REPLYTO) return null;
	if(sweep.type == const_sweep.TYPE_STORY_MENTION) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const link_blog_no_participants_fb = ((window.is_spanish) ? '2017/03/guia-definitiva-para-dar-visibilidad-a-un-sorteo-en-facebook/' : '2017/05/definitive-guide-to-give-visibility-to-facebook-sweepstakes/');
	const link_blog_no_participants_ig = ((window.is_spanish) ? '2017/08/guia-definitiva-para-dar-visibilidad-a-un-sorteo-de-comentarios-en-instagram/' : '2017/09/definite-guide-to-give-visibility-to-a-comments-based-instagram-sweepstakes/');

	return (
		<Message
			title="Your post has no participants yet"
		>
			<p>
				<FormattedMessage id="When the period for participating ends, return to this screen and the system will import all participants of your post on {network}. At that moment you'll be able to select the winners randomly." values={{ network:i18n(sweep.network, 'c') }} />
			</p>

			<p>
				<ActionLink
					_href={window.blog_base_url + ((sweep.network == const_sweep.ID_FACEBOOK) ? link_blog_no_participants_fb : link_blog_no_participants_ig)}
					_target="_blank"
					autotranslate={false}
				><FormattedMessage id="Guide to give visibility to a {network} post" values={{network:i18n(sweep.network, 'c')}} /></ActionLink>
			</p>
		</Message>
	)
}

class SweepSettings extends Component {
	constructor(props,context) {
		super(props, context);

		this.is_facebook = (props.sweep.network == const_sweep.ID_FACEBOOK) ? true : false;
		this.is_twitter = (props.sweep.network == const_sweep.ID_TWITTER) ? true : false;
		this.is_instagram = (props.sweep.network == const_sweep.ID_INSTAGRAM) ? true : false;
		this.is_multi = (props.sweep.network == const_sweep.ID_MULTI) ? true : false;
		this.is_list = (props.sweep.network == const_sweep.ID_LIST) ? true : false;

		this.is_story_replyto = (props.sweep.type == const_sweep.TYPE_STORY_REPLYTO) ? true : false;
		this.is_story_mention = (props.sweep.type == const_sweep.TYPE_STORY_MENTION) ? true : false;
		this.is_type_hashtag = (props.sweep.type == const_sweep.TYPE_HASHTAG) ? true : false;
		this.is_type_comment = (props.sweep.type == const_sweep.TYPE_COMMENT) ? true : false;
		this.is_type_like = (props.sweep.type == const_sweep.TYPE_LIKE) ? true : false;
		this.is_type_upload = (props.sweep.type == const_sweep.TYPE_UPLOAD) ? true : false;
		this.is_type_prize = (props.sweep.type == const_sweep.TYPE_PRIZE) ? true : false;

		if(this.is_twitter) props.sweep.config.num_followers = props.sweep.config.num_followers != undefined ? props.sweep.config.num_followers : 25;
		props.sweep.config.num_winners = props.sweep.config.num_winners != undefined && props.sweep.config.num_winners>0 ? sweep.config.num_winners : 1;
		props.sweep.config.num_substitutes = props.sweep.config.num_substitutes != undefined ? props.sweep.config.num_substitutes : 1;
		
		const i18n = (m, c) => i18nIntl(m, props.intl, c);
		if(this.is_story_mention || this.is_story_replyto) {
			//alert(view_params.agent.email)
			props.sweep.config.live_agent_email = props.sweep.config?.live_agent_email ?? window.agent_email;
			props.sweep.config.autoresponder_status = props.sweep.config?.autoresponder_status ?? 1;
			props.sweep.config.autoresponder_comment = props.sweep.config?.autoresponder_comment ?? i18n("Thanks for your message");
		}

		props.sweep.config.num_substitutes = props.sweep.config.num_substitutes != undefined ? props.sweep.config.num_substitutes : 1;
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const _auto_display_participants = urlParams.has('list_participants');
		//list_users
		this.state = {
			accept_certificate:false,
			accept_live_mode:false,
			actual_section_id:(window.location.hash != undefined && window.location.hash == '#confirm') ? 2 : 1,
			already_selected_collaborator_network:false,
			alternates_test:[],
			changes_config:false,
			fetching_selected_id:0,
			display_blacklist_suggestions:false,
			display_check_certificate:false,
			display_download_options:false,
			display_error_connect:false,
			display_error_connect_exception:'',
			display_error_export:false,
			//display_fullscreen_broadcast_mode:false,
			display_oldwinners:false,
			display_participants:_auto_display_participants,
			display_participants_images:false,
			display_generating_presentation:true,
			display_popup_title:false,
			display_prizes_layer:false,
			display_refresh_manual:false,
			display_refresh_post:false,
			display_save_message:false,
			display_save_status:false,
			display_test_winners:false,
			display_stats:false,
			in_draw:false,
			in_draw_counter:{partial:0,total:props.sweep.config.total_participants},
			has_gallery:false,
			need_subscription:false,
			numbers_random:[],
			live_url:false,
			organizers:props.organizers,
			oldwinners:[],
			options_collaborator:{
				link:'',
				name_collaborator:'',
				network:false,
			},
			options_live:{
				alternates:false,
				automatic:false,
				company:(props.sweep.config.company != undefined) ? props.sweep.config.company : '',
				title:props.sweep.title,
			},
			options_payment:[],
			outlimited:false,
			participants:[],
			participants_photo:[],
			pending_winners:[],
			post_on_refresh:false,
			prize_name:'',
			prize_qty:1,
			refresh_next_url:false,
			refresh_participants:0,
			rerequest:false,
			show_last_update:(props.vars!=undefined && props.vars.is_updatable!=undefined) ? props.vars.is_updatable : false,
			startDate:EPDate(),
			status:{},
			suggestions:[],
			sweep:props.sweep,
			test_advise:0,
			type:props.type,
			winners:[],
			winners_test:[],
			has_errors:false,
			enabled_save_prizes:false,
			display_alternates_alert_layer:false,
		}

		this.timezones = [];
		this.timezones.push({k:'', v:'-- '+i18n("Select")+' --'});
		for(var i in this.props.timezones){
			this.timezones.push({ k:i, v:this.props.timezones[i] });
		}
		this.time_block_time = (props.sweep.config.time_block_time != undefined) ? EPDate(props.sweep.config.time_block_time, 'YYYY-MM-DD HH:mm:ss') : EPDate();
		let _myAccount = window?.myAccount ?? {};
		this.time_block_timezone = props.sweep?.config?.time_block_timezone ?? (_myAccount?.agent?.timezone ?? 'UTC');
		this.date_format = (window.is_spanish) ? 'DD-MM-YYYY' : 'YYYY-MM-DD';
		this.time_format = 'HH:mm';

		//events
		this.event_export = { platform:'panel', category:'admin', action:'link', value:'buy_subs_basic_'+sweep.network+'_exportxls' };
		this.data_stats = false;

		var swp = this.props.sweep != undefined ? this.props.sweep : false;
		if(this.is_multi) {
			//Allowed selection
			this.max_posts_selecteds = swp ? (const_sweep.MAX_POSTS_SELECTEDS_MULTI-swp.number_of_posts) : const_sweep.MAX_POSTS_SELECTEDS_MULTI;
		} else {
			this.max_posts_selecteds = ((this.props.subspro || this.props.subsbasic)) ? const_sweep.MAX_POSTS_SELECTEDS : 1;

			if(swp.type == const_sweep.TYPE_LEAD_ADS)this.max_posts_selecteds = 1;
		}
		window.handleClickSettings = this;
	}

	componentWillMount() {
		importCSS('comp/sweeps.css');
	}

	componentDidMount() {
		this.statusSweep();

		if(this.props.vars!=undefined && this.props.vars.num_won > 0) this.fetchOldWinners(1, (d) => this.fetched2(d.data));
		this.setState({...this.state});
		const sweep_label = this.state.sweep.label != undefined ? this.state.sweep.label[0] : {};
		if(_size(sweep_label)>0 && this.props.roles!=undefined)removeByRole(sweep_label,this.props.roles);
	}

	componentDidUpdate() {
		const sweep_label = this.state.sweep.label != undefined ? this.state.sweep.label[0] : {};
		if(_size(sweep_label)>0 && this.props.roles!=undefined)removeByRole(sweep_label,this.props.roles);
	}

	pending(cb) {
		alert('pending');
		if(cb != undefined) cb();
	}

	displaySweepStats() {
		this.state.display_stats = !this.state.display_stats;
		this.setState({...this.state});
	}

	toggleRefreshManual() {
		this.state.display_refresh_manual = !this.state.display_refresh_manual;
		this.setState({...this.state});
	}
	togglePopupTitle() {
		this.state.display_popup_title = !this.state.display_popup_title;
		this.setState({...this.state});
	}

	closeErrorConnect() {
		this.state.display_error_connect = !this.state.display_error_connect;
		if(!this.state.display_error_connect)this.state.display_error_connect_exception ='';
		this.setState({...this.state});
	}

	receiveCollaboratorFromSidebar(collaborator){
		var collaborators = this.state.sweep.config.collaborations != undefined ? this.state.sweep.config.collaborations : [];
		this.changeConfig('collaborations',collaborators.concat(collaborator))
	}


	failurePost(action){
		if(action == 'new'){
			$.post(getRemotedbUrl('/sweeps/delete'), { 'id':this.state.sweep.id }, (response) => {
				if(response.status) {
					window.location.href = response.location_url;
				}
			}, 'json');
		}else if(action == 'post'){
			this.closeErrorConnect();
			this.toggleMultipost();
		}
	}

	toggleDownloadOptions() {
		this.state.display_participants = false;
		if(this.props.subsbasic && this.state.sweep.config.total_participants<=const_sweep.LIMIT_SUBSCRIPTION_PRO || this.props.subspro) {
			this.state.display_download_options = !this.state.display_download_options;
		} else {
			this.state.display_error_export = !this.state.display_error_export;
		}
		this.setState({...this.state});
	}

	closeLayerErrors() {
		//All layer error close here
		this.state.display_error_export = false;
		this.setState({...this.state});
	}

	closeTestLayer() {
		//All layer error close here
		this.state.display_test_winners = false;
		this.state.winners_test = [];
		this.state.alternates_test = [];
		this.setState({...this.state});
	}

	toggleParticipants() {
		this.state.display_participants = !this.state.display_participants;
		if(!this.state.display_participants){
			this.state.display_participants_images = false;
		}
		this.setState({...this.state});
	}

	toggleBlacklistSuggestion() {
		this.state.display_blacklist_suggestions = !this.state.display_blacklist_suggestions;
		this.setState({...this.state});
	}

	toggleOldWinners() {
		this.state.display_oldwinners = !this.state.display_oldwinners;
		this.setState({...this.state});
	}

	toggleCertificates(test) {
		this.state.display_check_certificate = !this.state.display_check_certificate;
		this.state.display_confirm = !this.state.display_check_certificate;
		this.setState({...this.state});
	}

	save(cb, check_winners_and_alternates) {
		var sweep = this.state.sweep;

		if(check_winners_and_alternates!=undefined && check_winners_and_alternates){//Checking winners to result
			sweep.check_winners_and_alternates = check_winners_and_alternates;
		}else if(sweep.check_winners_and_alternates!=undefined){
			delete sweep.check_winners_and_alternates;
		}

		$.post(getRemotedbUrl('/sweeps/save/'+this.props.sweep.id), {sweep:JSON.stringify(sweep)}, (result) => {
			this.stateStatus(result);
			if(cb != undefined) cb(result);
		}, 'json');
	}

	statusSweep() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const sweep = this.state.sweep;

		$.post(getRemotedbUrl('/sweeps/status_sweep/'+this.props.sweep.id), (result) => {
			//for payments
			this.state.status = result;
			const status_pay = this.state.status;
			const is_giveaway_list = (this.is_list && this.is_type_upload) ? true : false;

			var options_pay = [];
			var options_default = false;
			if(status_pay.outlimit>0){
				this.state.outlimited = status_pay.outlimit;
			} else if(status_pay.pay_subscription > 0) {
				if(status_pay.pay_subscription <= 2 || true) {
					var obj = {};
					obj.off = status_pay.pay_subscription > 2;
					obj.off_message = status_pay.pay_subscription > 2 ? this.props.intl.formatMessage({id:"Maximum {limit_participants_basic} participants per promotion exceeded."},{limit_participants_basic: window.limit_list_plans[2]}): false;
					obj.value = const_sweep.plan_basic;
					obj.label = <FormattedMessage id="{plan} for {price}" values={{plan:i18n(window.resume_plans[2]['name']),price:window.resume_plans[2]['monthly']}} />;

					var aftermessage = '';
					if(this.is_instagram) {
						aftermessage += i18n("Select random winners from Instagram posts")+'.<br />';
						aftermessage += i18n("Export comments to an Excel/CSV file")+'.<br />';
						aftermessage += i18n("Unlimited time for monitoring process of new comments")+'.<br />';
						aftermessage += i18n("Support for multiple sweepstakes from single post")+'.<br />';
					}

					aftermessage += i18n("The basic plan includes unlimited Facebook, Twitter, Instagram and Youtube Sweepstakes, Pick-a-Winner App and other basic applications.")+'<br />'+i18n("The renewal is automatic but you can cancel the plan at any time");
					//aftermessage += <ActionLink _href={window.zendesk_base_url + '207885196'} _target="_blank">More information</ActionLink>
					obj.after_message = <div dangerouslySetInnerHTML={{ __html:aftermessage}}></div>
					obj.extra_contents_whole = true;
					options_pay.push(obj);
					options_default = status_pay.pay_subscription <= 2 ? const_sweep.plan_basic : options_default;
				}

				if(status_pay.pay_subscription <= 3 || true) {
					var obj = {};
					obj.off = status_pay.pay_subscription > 3;
					obj.off_message = status_pay.pay_subscription > 3 ? (is_giveaway_list ? this.props.intl.formatMessage({id:"Maximum {limit_participants_basic} participants per promotion exceeded."},{limit_participants_basic:window.limit_list_plans[3]}) : i18n("Option disabled")) : false;
					obj.value = const_sweep.plan_pro;
					obj.label = <FormattedMessage id="{plan} for {price}" values={{plan:i18n(window.resume_plans[3]['name']),price:window.resume_plans[3]['monthly']}} />;
					var aftermessage = '';
					aftermessage += i18n("Enjoy all BASIC features, plus the Multi-Network app. Run a single giveaway across multiple social networks.")+'<br />';
					aftermessage += i18n("Unlimited number of participants.")+'<br />';
					aftermessage += i18n("Support for sponsored posts on Facebook, Instagram, and Twitter.");
					obj.after_message = <div dangerouslySetInnerHTML={{ __html:aftermessage}}></div>;
					obj.extra_contents_whole = true;
					options_pay.push(obj);
					options_default = status_pay.pay_subscription <= 3 ? const_sweep.plan_pro : options_default;
				}

				if(is_giveaway_list) {
					if(status_pay.pay_subscription <= 4 || true) {
						var obj = {};
						obj.off = status_pay.pay_subscription > 4;
						obj.off_message = status_pay.pay_subscription > 4 ? (is_giveaway_list ? this.props.intl.formatMessage({id:"Maximum {limit_participants_basic} participants per promotion exceeded."},{limit_participants_basic:window.limit_list_plans[4]}) : i18n("Option disabled")): false;
						obj.value = const_sweep.plan_premium;
						obj.label = <FormattedMessage id="{plan} for {price}" values={{plan:i18n(window.resume_plans[4]['name']),price:window.resume_plans[4]['monthly']}} />;
						var aftermessage = i18n("The best-selling Easypromos plan because it includes giveaways on social networks, list giveaways for up to 500,000 entries, and all gamification applications to entertain and attract new users. More than 30 app to engage with your community.");
						obj.after_message = <div dangerouslySetInnerHTML={{ __html:aftermessage}}></div>;
						obj.extra_contents_whole = true;
						options_pay.push(obj);
						options_default = status_pay.pay_subscription <= 4 ? const_sweep.plan_premium : options_default;
					}

					if(status_pay.pay_subscription <= 5 || true) {
						var obj = {};
						obj.off = status_pay.pay_subscription > 5;
						obj.off_message = status_pay.pay_subscription > 5 ? i18n("Option disabled"): false;
						obj.value = const_sweep.plan_wl;
						obj.label = <FormattedMessage id="{plan} for {price}" values={{plan:i18n(window.resume_plans[5]['name']),price:window.resume_plans[5]['monthly']}} />;
						var aftermessage = i18n("The most comprehensive Easypromos plan. It includes all the applications in the catalog, and allows List Giveaways for up to 1,000,000 entries. The ideal plan for marketing teams managing large brands.");
						obj.after_message = <div dangerouslySetInnerHTML={{ __html:aftermessage}}></div>;
						obj.extra_contents_whole = true;
						options_pay.push(obj);
						options_default = status_pay.pay_subscription <= 5 ? const_sweep.plan_premium : options_default;
					}
				}
			}
			this.state.need_subscription = options_default;
			this.state.options_payment = options_pay;
			this.setState({...this.state});
		}, 'json');
	}

	gotoConfirm(skip,cb) {

		const sweep = this.state.sweep;
		var go_to_confirm = true;
		if(!skip){
			const need_refresh = (sweep.status == const_sweep.OPENED && (this.is_facebook || this.is_instagram) || this.is_twitter && sweep.config.premium==undefined ) ? true : false
			const date_last_update = EPDate(sweep.report.last_import_date);
			var total = EPDateDiff(null, date_last_update, 'hours');
			go_to_confirm = (need_refresh && total>=3) ? false : true;
		} else {
			this.state.display_refresh_manual = false;
		}
		if(go_to_confirm){
			if(!this.state.display_alternates_alert_layer && sweep.config.num_substitutes == 0 && this.is_list){//permetem 0 suplents a listado
				this.setState({display_alternates_alert_layer:true});
				if(cb != undefined) cb();
			}else{
				this.setState({display_alternates_alert_layer:false});
				this.save(
					(result) => {
						if(result.status) {
							if(this.state.need_subscription) {
								window.location.href = window.panel_url + 'plans/add/'+this.state.need_subscription+'/?radiobutton';
							} else {
								this.setState({ actual_section_id:2 });
								window.location.hash = '#confirm';
							}
						}
						if(cb != undefined) cb();
					},true)
				}


		}else{
			this.toggleRefreshManual();
			if(cb != undefined) cb();
		}
	}

	backConfirm() {
		this.setState({ actual_section_id:1 });
		window.location.hash = '';
	}

	fetched2(data) {
		this.state.oldwinners=this.state.oldwinners.concat(data);
		this.setState({...this.state}) ;
	}

	fetchOldWinners(page, cb) {
		var d = {};
		if(page)d.p = page;
		if(this.state.oldwinners.length<this.props.vars.num_won){
			$.get(getRemotedbUrl('/sweeps/old_winners/'+this.props.sweep.id), d, function(result) {
				if(result.status){
					var has_more = this.state.oldwinners.length + result.elements.length < this.props.vars.num_won;
					if(cb) cb({ data:result.elements, hasMore:has_more });
				}else{
					this.stateStatus(result);
				}
			}.bind(this),'JSON');
		}
	}

	stateStatus(result) {
		this.state.display_save_status = result.status ? 'ok' : 'ko';
		this.state.display_save_message = result.message;
		this.state.changes_config = !result.status ? true : false;
		this.state.display_popup_title = false;
		this.state.display_check_certificate = false;
		this.state.accept_certificate = false;
		if(result.sweep!=undefined)this.state.sweep = result.sweep;

		this.setState({...this.state});
		setTimeout(function() {
			this.state.display_save_status = false;
			this.state.display_save_message = false;
			this.setState({...this.state});
		}.bind(this), 2500);
	}

	saveHashtag(hashtag) {
		var config_hashtags = (this.state.sweep.config.hashtags != undefined) ? this.state.sweep.config.hashtags : [];
		var found_hashtag = false;
		config_hashtags.map((item,i) => {
			if(item == hashtag){
				config_hashtags.splice(i, 1);
				found_hashtag = true;
				return;
			}
		});

		if(!found_hashtag)config_hashtags.push(hashtag);
		this.state.sweep.config.hashtags = config_hashtags;
		this.setState({...this.state});
		this.save();
	}

	changeState(k, v) {
		this.state[k] = v;
		this.setState({...this.state});
	}

	change(k, v) {
		this.state.sweep[k] = v;
		this.setState({...this.state});
	}

	changeConfig(k, v) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		if(!this.state.changes_config) this.state.changes_config = true;
		
		if(k == 'autoresponder_comment'){
			v = v.replace(/(https?:\/\/(www\.)|ftps?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/g, '');
		}
		if(k == 'time_block_flg'){
			if(v){
				this.state.sweep.config['time_block_time'] =  this.time_block_time;
				this.state.sweep.config['time_block_timezone'] = this.time_block_timezone;
			}else{
				delete this.state.sweep.config['time_block_time'];
				delete this.state.sweep.config['time_block_timezone'];
			}
		}
		if(k == 'time_block_time') {
			this.state.sweep.config[k] = v.format(this.date_format + ' ' + this.time_format+':00');
			this.time_block_time = v;
		} else {
			this.state.sweep.config[k] = v;
		}

		this.setState({...this.state});
	}

	intervalDoSweep() {
		let counter = 0;
		const total_loops = Math.ceil(this.state.sweep.total_participants/50000);
		const intervalo = setInterval(() => {
			counter++;
			this.setState({in_draw_counter:{partial:counter*50000,total:this.state.sweep.total_participants}})
			if (counter >= total_loops) {
				clearInterval(intervalo);
			}
		}, 1000); // cada 1000 ms (1 segundo)

	}

	doSweep(test, live, cb) {
		if(window.features?.includes('sweep_list_v24') &&
			sweep.network == const_sweep.ID_LIST &&
			sweep.type == const_sweep.TYPE_UPLOAD){
			this.setState({in_draw:test ? 'test' : 'real'});
			this.intervalDoSweep();
			$.get(getRemotedbUrl(`/v24/sweeps/draw/${sweep.id}/${test}`), (result) => {
				if(result.status) {
					if(test){
						this.end_sweep_test(result,cb);
						this.setState({in_draw:false});	
					}else{
						var end_sweep = {test:false};
						if(this.state.finalists_total != undefined)end_sweep.finalists_total = this.state.finalists_total;
						if(live)end_sweep.live = this.state.options_live;
						$.post(getRemotedbUrl(`/sweeps/end_sweep/${sweep.id}`), end_sweep, (result2) => {
							if(result2.status) {
								if(live && result2.live_url != undefined) {
									if(sweep.type != const_sweep.TYPE_LIVE){
										window.location.href = result2.live_url + '?autoplay=1&confirm=1';
									}
									if(cb != undefined) cb(result2);
								} else {
									window.location.href = window.panel_url + 'sweeps/success/' + this.props.sweep.id;
								}
							} else {
								alert(result2.message);
								if(cb != undefined) cb();
							}
							this.setState({in_draw:false});	
						}, 'json');
					}
				} else {
					this.stateStatus(result);
					this.setState({in_draw:false});	
					if(cb != undefined)cb();
				}
			}, 'json');
		}else{
			$.post(getRemotedbUrl('/sweeps/do_sweep/'+sweep.id), {test:test}, (result) => {
				if(result.status) {
					this.state.winners = [];
					this.state.pending_winners = result.pending_winners;
					if(result.finalists_total!=undefined)this.state.finalists_total = result.finalists_total;
					this.extractWinners(test,live,cb);
				} else {
					this.stateStatus(result);
				}
				if(cb != undefined)cb();
			}, 'json');
		}
	}

	doLiveSweep(options, cb) {
		this.setState({ options_live:options });
		this.doSweep(0, 1, cb);
	}

	checkWinner(winner,cb){
		const sweep = this.state.sweep;
		//Fer la funcio
		if(winner!=undefined){//Maybe winner with more entries
			var winner_split = (winner.uid).split('_');
			if(winner_split[0] == 'twitter' && sweep.config.nofollowers_flg == true){
				$.post(getRemotedbUrl('/sweeps/check_winner/'+this.props.sweep.id), {winner:winner.uid}, (result) => {
					if(cb != undefined)	cb(result.status);
				},'JSON');
			}else{
				if(cb != undefined)	cb(1);
			}
		}else{
			if(cb != undefined)	cb(1);
		}
	}

	getWinnersByNumbers(numbers,index_number,cb){
		var pending_winners = this.state.pending_winners;
		var winners = this.state.winners;
		const number_random = numbers[index_number];

		const sweep = this.state.sweep;

		var winner = pending_winners.filter(function(obj){ return number_random<=obj.max && number_random>=obj.min; })[0];
		this.checkWinner(winner,(checked_to_win)=>{
			if(checked_to_win){
				var key_winner = pending_winners.indexOf(winner);
				if (key_winner > -1) {

					var assigned_count = _size(winners);
					if(assigned_count < parseInt(sweep.config.num_winners)) {
						// winners
						winners.push({id:winner.uid, prize:1, backup: 0, order:assigned_count+1});
					} else {
						// alternates
						winners.push({id:winner.uid, prize:0, backup: 1, order:assigned_count+1});
					}
					this.setState({winners:winners});
				}
			}else{
				var key_winner = pending_winners.indexOf(winner);//NO follower ppal
			}

			if(key_winner>-1){
				this.resetWinnersAndEntries(key_winner);
			}

			if(cb != undefined)	cb({key_winner:key_winner,winner:winner},cb);
		});
	}

	resetWinnersAndEntries(key_winner){
		var pending_winners = this.state.pending_winners;
		pending_winners.splice(key_winner, 1);

		var actual_key = 0;
		for(var k=0; k < pending_winners.length; k++) {
			var min = pending_winners[k].min;
			var max = pending_winners[k].max;
			var diferencia_min_max = max - min;
			if(actual_key!=min){
				pending_winners[k].min = actual_key;
				pending_winners[k].max = actual_key + diferencia_min_max;
			}
			var diferencia_min_max = diferencia_min_max + 1;//And next
			actual_key+=diferencia_min_max;
		}
		this.state.pending_winners = pending_winners;//setejem de nou l'state dels usuaris pendents d'assignar
		this.setState({...this.state});
	}

	extractWinners(test, live, cb) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const sweep = this.state.sweep;
		var pending_winners = this.state.pending_winners;
		this.keys_to_remove = [];//with new min-max
		var total_pending_winners = pending_winners.length;
		var lastItem = pending_winners[total_pending_winners-1];
		var winners = this.state.winners;

		var total_winners = _size(winners);
		var total_prizes = parseInt(sweep.config.num_winners) + parseInt(sweep.config.num_substitutes) - parseInt(total_winners);
		var winners_set = parseInt(total_winners) >= parseInt(sweep.config.num_winners) + parseInt(sweep.config.num_substitutes);
		if(!winners_set) {
			if(_size(pending_winners)>=total_prizes){
				$.post(getRemotedbUrl('/sweeps/get_number_random/'+this.props.sweep.id), {max:lastItem['max'],total:total_prizes}, (result) => {
					if(result.status) {
						this.state.numbers_random = this.state.numbers_random.concat(result.numbers);

						var count_number = 0;
						this.getWinnersByNumbers(result.numbers,count_number,(resp,cb2)=>{
							count_number++;
							if(count_number<_size(result.numbers)){
								this.getWinnersByNumbers(result.numbers,count_number,cb2);
							}else{
								winners = this.state.winners;
								winners_set =  parseInt(winners.length) >= parseInt(sweep.config.num_winners) + parseInt(sweep.config.num_substitutes);

								if(!winners_set){//cal reposicionar indexs min-max if no all setted, else sudo!

									this.keys_to_remove.map((participant_winner, key_winner) => {
										this.resetWinnersAndEntries(key_winner);
									});
									this.keys_to_remove.splice(0, this.keys_to_remove.length);//Removeall
								}
								this.state.winners = winners;//setejem de nou l'state dels usuaris pendents d'assignar
								this.setState({...this.state});
								this.extractWinners(test,live,cb);//recall self, not end
							}
						});
					} else {
						this.stateStatus(result);
						if(cb != undefined)	cb();
					}
				}, 'JSON');
			}else{
				this.stateStatus({status:0,message:i18n("Sorry, there are less participants than winners and alternates")});
				if(cb != undefined)	cb();
			}
		} else {
			this.insertWinners(test,live,cb);
		}
	}

	end_sweep_test(result, cb) {
		this.state.display_test_winners = true;
		this.state.winners_test = result.winners;
		this.state.alternates_test = result.alternates;
		this.setState({...this.state});

		setTimeout(() => {
			var rotation = Math.atan(($('.this_section').height() + 2) / $('.this_section').width() + 2);
			rotation = 90 - (180 * rotation / Math.PI);
			this.setState({ test_advise:-rotation + 'deg' });
		}, 20);
		if(cb != undefined) cb(result);
	}

	insertWinners(test,live,cb) {
		$.post(getRemotedbUrl('/sweeps/insert_winners/'+this.props.sweep.id), {test:test,winners:JSON.stringify(this.state.winners)}, (result) => {
			if(result.status) {
				var end_sweep = {};
				end_sweep.test = test;
				if(this.state.finalists_total!=undefined)end_sweep.finalists_total = this.state.finalists_total;
				end_sweep.finalists = result.finalists;
				end_sweep.numbers = this.state.numbers_random;
				if(live){
					end_sweep.live = this.state.options_live;
				}

				$.post(getRemotedbUrl('/sweeps/end_sweep/' + this.props.sweep.id), end_sweep, (result2) => {
					if(result2.status) {
						if(test) {
							this.end_sweep_test(result2);
						} else if(live && result2.live_url != undefined) {
							const sweep = this.state.sweep;

							if(sweep.type != const_sweep.TYPE_LIVE){
								window.location.href = result2.live_url + '?autoplay=1&confirm=1';
							}
							if(cb != undefined) cb(result2);
						} else {
							window.location.href = window.panel_url + 'sweeps/success/' + this.props.sweep.id;
						}
					} else {
						this.stateStatus(result2);
						if(cb != undefined) cb();
					}
				}, 'json');
			} else {
				this.stateStatus(result);
				if(cb != undefined)	cb();
			}
		},'json');
	}

	go_to_success(){
		window.location.href = window.panel_url + 'sweeps/success/' + this.props.sweep.id;
	}

	refreshSweep() {
		this.state.display_refresh_manual = false;
		this.state.display_refresh_post = true;
		this.setState({...this.state});

		const by_instagram_api = this.state.sweep?.config?.owner_id ?? false;
		const url = `/sweeps/status_sweep_${(by_instagram_api) ? 'ig' : 'fb'}/${this.state.sweep.id}`;
		$.get(getRemotedbUrl(url),(result) => {
			if(result.status==1){
				var posts = [];
				if(_size(this.state.sweep.post_id)>0){
					$.each(this.state.sweep.post_id, (i, item) => {
						if(item.collaborator == undefined){//not refresh
							posts.push(item);
						}
					});
				}
				this.state.refresh_participants = 0;

				if(_size(posts)>0){
					this.refreshOneByOne(posts, 0, () => {
						this.state.display_refresh_post = false;
						this.checkUpdatable();
						this.setState({...this.state});
					});
				}else if(this.is_twitter && this.state.sweep.type == const_sweep.TYPE_FOLLOWER && result.sweep!=undefined){//Ja fa el refresh
					if(result.sweep)this.state.sweep = result.sweep;
					this.state.display_refresh_post = false;
					this.setState({...this.state});
				}
			}else if(result.status == 2){
				//Nothing, from refresh and on_update=1
			}else{
				this.state.display_error_connect = true;
				this.state.display_error_connect_exception = result.exception;
				this.state.display_refresh_post = false;
				this.setState({...this.state});
			}
		});
	}

	transferInformationToSweep(result, type,cb) {
		if(type == 'add') {
			this.state.sweep.post_id = result.posts;
			this.refreshSweep();
		} else if(type == 'edit') {
			this.state.sweep.post_id = result.posts;
			this.setState({...this.state});
			this.save(cb);
		}  else {
			this.state.sweep = result.sweep;
		}

		this.setState({...this.state});
	}

	refreshOneByOne(items, i, cb) {
		if(items[i] != undefined) {
			this.refreshPost(items[i].post_id, 0, () => {
				this.state.fetching_selected_id = i;
				this.refreshOneByOne(items, (i + 1), cb)
			});
		} else {
			if(cb != undefined)	cb();
		}
	}

	refreshPost(post_id, counter_call, cb) {

		if(counter_call>10){
			this.state.refresh_next_url = false;
			this.state.post_on_refresh = false;
			if(cb != undefined)	cb();
		}else{
			this.state.post_on_refresh = this.state.sweep.post_id[post_id];
			this.setState({...this.state});
			var url = '/sweeps/getcontents/' + this.props.sweep.id + '/' + post_id;
			if(this.state.refresh_next_url) url += '/' + this.state.refresh_next_url +'/1';
			else url += '/0/1';

			$.ajax({
			    url:getRemotedbUrl(url),
			    type: "GET",
			    timeout: 30000,
			    dataType: 'json',
			    success: (response) => {
			    	if(response.status) {
						if(response.total_participants != undefined) {
							var swp = this.state.sweep;
							swp.config.total_participants = parseInt(swp.config.total_participants) + parseInt(response.total_participants);
							this.state.refresh_participants = parseInt(this.state.refresh_participants) + parseInt(response.total_participants);
							this.state.sweep = swp; //INIT
						}

						if(response.finished) {
							this.state.refresh_next_url = false;
							this.state.post_on_refresh = false;
							this.state.sweep = response.sweep;
							if(cb != undefined)	cb();
						} else {
							this.state.refresh_next_url = response.paging_url;
							this.refreshPost(post_id,0,cb);
						}

					}else if(response.error!=undefined){
						this.state.display_error_connect = true;
						this.state.refresh_next_url = false;
						this.state.post_on_refresh = false;
						this.state.display_refresh_post = false;
					}
					this.setState({...this.state});

			    },
			    error: (x, t, m) => {
			    	counter_call++;
			    	this.refreshPost(post_id,counter_call,cb);//Recall same call
			    }
			});
		}
	}

	checkUpdatable() {
		$.get(getRemotedbUrl('/sweeps/check_updatable/'+this.props.sweep.id),(result) => {
			var last_update = result.status ? true : false;
			this.setState({ show_last_update:last_update });
		}, 'JSON');
	}

	totalPrizes() {
		var cfg = this.state.sweep.config;
		var num_winners = 0;
		cfg.prizes.map((prize, i) => {
			num_winners+=parseInt(prize.qty);
		});
		cfg.num_winners = num_winners;
		this.state.sweep.config = cfg;
		this.state.changes_config = true;
		this.state.enabled_save_prizes = true;
		this.setState({...this.state});
	}

	createPrize() {
		var cfg = this.state.sweep.config;
		const name = this.state.prize_name;
		const qty =  parseInt(this.state.prize_qty);

		if(name != '' && qty > 0) {
			if(cfg.prizes == undefined){
				cfg.prizes = [];
			}
			cfg.prizes.push({name:name,qty:qty});
			this.state.prize_name='';
			this.state.prize_qty=1;
			this.totalPrizes();
		}
	}

	removePrize(index){
		var prizes = this.state.sweep.config.prizes;
		prizes.splice(index,1);
		this.state.sweep.config.prizes = prizes;
		this.totalPrizes();

	}

	closeAndSavePrizes(cb) {
		this.save(()=>{
			this.state.display_prizes_layer = false;
			this.state.enabled_save_prizes = false;
			this.setState({...this.state});
			if(cb != undefined) cb();
		});
	}

	getPrize(index){
		var all_prizes = [];
		var prizes = this.state.sweep.config.prizes;
		var numprize = 0;
		prizes.map((prize, i) => {
			for (var j = 0 ; j < prize.qty; j++) {
				all_prizes[numprize] = prize.name
				numprize++;
			}
		});
		return all_prizes[index];
	}

	toggleMultipost() {
		this.state.display_multipost = !this.state.display_multipost;
		this.setState({...this.state});
	}
	
	validateFields(passed) {
		this.state.has_errors = !passed;
		this.setState({...this.state});
	}

	fetchFinalists(value, cb) {
		var suggestions = [];
		var value_finalist = accent_fold(value.value.toLowerCase());
		if(value_finalist.length>=2){
			if(this.wait3 != undefined) clearInterval(this.wait3);
			this.wait3 = setTimeout(() => {
				if(this.req3 != undefined) this.req3.abort();
				this.req3 = $.post(getRemotedbUrl('/sweeps/load_search_users/'+this.state.sweep.id) , {value:value_finalist}, (response) => {
					if(response.results!=undefined){
						$.each(response.results, function(i, item) {
							var array = [];
							array['value'] = <div>{(item.image!=undefined) && (<img src={item.image} width="25" height="25"/>)}<span>{item.name}</span></div>;
							array['data'] = item;
							suggestions.push(array);
						});
						cb(suggestions);
					}
				}, 'json');
			}, 500);
		}
	}

	blacklist(participant,action) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		var already_blacklisted = false;

		var unique_id = participant.net_id!=undefined ? participant.net_id : participant.fbuid

		if(window.blacklist[unique_id] != undefined) {
			if(action!='add')delete window.blacklist[unique_id];
			already_blacklisted = true;
		} else {
			window.blacklist[unique_id] = participant.network;

			for(var i in window.suggestions){
				if(window.suggestions[i].net_id === unique_id && participant.page.id == window.suggestions[i].page.id){
					window.suggestions.splice(i,1);
					break;
				}
			}
		}
		if(action != 'add' || !already_blacklisted){
			var sweep = this.state.sweep;
			if(this.is_multi) {
				//page
				participant.page = {id:sweep.page_id,name:sweep.config.name};
			}

			$.post(getRemotedbUrl('/sweeps/action_blacklist/'+participant.network), participant, function(result) {
				this.stateStatus(result);
			}.bind(this), 'json');
			this.setState({...this.state});
		}else if(action=='add' && already_blacklisted){
			this.stateStatus({status:0,message:i18n("User already blacklisted")});
		}
	}

	exclude(participant,action) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		var sweep = this.state.sweep;
		var net_id = participant.net_id;
		var already_excluded = false;
		if(sweep.config.exclude != undefined) {
			sweep.config.exclude.map((item, i) => {
				if(item != undefined && item.net_id == net_id) {
					already_excluded = true;
					if(action!='add')sweep.config.exclude.splice(i,1);
					return;
				}
			});
		} else {
			sweep.config.exclude = [];//Not created, initialize
		}
		if(!already_excluded) {
			if(participant.image!=undefined)delete participant.image;//Unnecessary information on exclusion
			if(participant.username!=undefined)delete participant.username;//Unnecessary information on exclusion
			sweep.config.exclude.push(participant);
		}

		if(action != 'add' || !already_excluded){
			this.state.sweep = sweep;
			this.setState({...this.state});
			this.save();
		}

		if(action == 'add' && already_excluded){
			this.stateStatus({status:0,'message':i18n("User already excluded")})
		}
	}

	rerequest(network,cb){
		var sweep = this.state.sweep;
		var pages = [];
		pages.push({id:sweep.page_id});

		this.setState({...this.state});
		FB.api('/me/permissions/', 'DELETE', (response) => {
			$.post(getRemotedbUrl('/sweeps/remove_tokens_session/'+sweep.id),{pages:pages},(resp)=>{
				if(resp.status == '1'){
					this.state.rerequest=true;
					this.setState({...this.state});
					if(cb!=undefined)cb();
				}
			},'JSON');
		});
	}



	rerequest_login(network,cb){
		var permissions = [];
		switch(network) {
			case const_sweep.ID_FACEBOOK:
				permissions.push("public_profile");
				//permissions.push("manage_pages");
				permissions.push("pages_show_list");
				permissions.push("pages_read_engagement");
				permissions.push("pages_read_user_content");
				break;
			case const_sweep.ID_INSTAGRAM:
				permissions.push("public_profile");
				//permissions.push("manage_pages");
				permissions.push("pages_show_list");
				permissions.push("pages_read_engagement");
				permissions.push("pages_read_user_content");
				permissions.push("instagram_basic");
				break;
		}

		FB.login((response2) => {
			if(response2.authResponse) {
				this.state.rerequest=false;
				this.state.display_error_connect=false;
				this.setState({...this.state});
				if(cb!=undefined)cb();
			}
		},{scope: permissions.join(),auth_type: 'rerequest'});
	}

	saveLiveSettings(options, cb) {
		this.saveConfigField('live',options,cb);
	}

	saveConfigField(field,value,cb) {
		$.post(getRemotedbUrl('/sweeps/saveConfigField/'+this.props.sweep.id), { field:field,value:value }, function(result) {
			this.state.sweep.config[field] = value;
			this.setState({...this.state});
			if(cb != undefined) cb(result);
		}.bind(this), 'json');
	}

	setLabelSweep(label){
		if(label!=undefined){
			this.state.sweep.label = [];
			this.state.sweep.label.push(label);

			const label_exist = this.state.organizers.filter((obj)=>{return obj.id == label.id})[0];
			if(!label_exist){
				//when create, already assigned
				this.state.organizers.push(label);
				this.state.display_popup_title = false;
			}
			this.setState({...this.state});
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const vars = this.props.vars!=undefined ? this.props.vars : {};
		let sweep = this.state.sweep;
		const type = this.props.type;

		const is_giveaway_list = (this.is_list && this.is_type_upload) ? true : false;

		const disabled = (sweep.status == const_sweep.CLOSED) ? true : false;
		const is_twitter_premium = sweep.config.premium!=undefined && sweep.config.premium && this.is_twitter ? true :false;

		var show_fb = false;
		var show_ig = false;
		var show_tw = false;
		var show_yt = false;
		if(this.is_facebook) show_fb = true;
		if(this.is_instagram) show_ig = true;
		if(this.is_twitter) show_tw = true;
  
		var post_id = [];
		if(_size(sweep.post_id) > 0) {
			$.each(sweep.post_id, (i, item) => {
				if(this.is_multi) {
					if(item.network == const_sweep.ID_FACEBOOK)show_fb = true;
					if(item.network == const_sweep.ID_INSTAGRAM) show_ig = true;
					if(item.network == const_sweep.ID_TWITTER) show_tw = true;
				}
				item.post_id=i;
				post_id.push(item);
			});
		}

		var multiple_post = 0;
		var array_multiple_post = [];
		var show_multiple_post = false;
		if(this.is_type_comment) {
			(multiple_post += show_fb) ? 1 : 0;
			(multiple_post += show_ig) ? 1 : 0;
			(multiple_post += show_tw) ? 1 : 0;
			(multiple_post += show_yt) ? 1 : 0;
			show_multiple_post = (multiple_post == 1 && _size(sweep.post_id) > 1) ? true : false;
			if(show_multiple_post){
				for (var i = 1; i <= _size(sweep.post_id); i++) {
					array_multiple_post.push({k:i,v:i});
				}
			}
		}

		//hashtags
		var has_hashtags = false;
		var hashtags = [];
		var total_hashtags = 0;
		if(sweep.report.hashtags != undefined && sweep.report.hashtag_user_count > 0 && sweep.config.total_participants <= const_sweep.HASHTAG_EXCLUSION_LIMIT) {
			has_hashtags = true;

			var sortable = [];
			for(var hashtag in sweep.report.hashtags) {
				sortable.push([hashtag, sweep.report.hashtags[hashtag]]);
			}

			sortable.sort(function(a, b) {
				return parseInt(b[1]) - parseInt(a[1]);
			});

			sortable.map((item,i) => {
				var checkhash = (sweep.config.hashtags != undefined) ? ((sweep.config.hashtags.indexOf(item[0]) >= 0) ? true : false) : false;

				hashtags.push({ name:item[0], value:item[1], selected:checkhash });
				total_hashtags += parseInt(item[1]);
			});
		}

		//Mentions
		var num_mentions = [{ k:0, v:'-- '+i18n("No mentions required")+' --'},
							{ k:1, v:this.props.intl.formatMessage({id:"At least {num} mention"},{num:1})  },
							{ k:2, v:this.props.intl.formatMessage({id:"At least {num} mentions"},{num:2}) },
							{ k:3, v:this.props.intl.formatMessage({id:"At least {num} mentions"},{num:3}) },
							{ k:4, v:this.props.intl.formatMessage({id:"At least {num} mentions"},{num:4}) },
							{ k:5, v:this.props.intl.formatMessage({id:"At least {num} mentions"},{num:5}) }];
		//Characters
		var num_characters = [{ k:0, v:'-- '+i18n("No limit")+' --'}];
		for (var i = 5; i <= 300; i+=5) {
			num_characters.push({k:i,v:i})
		}

		const timezones = this.timezones;

		var excludeds = [];
		var excludeds_users = [];
		if(sweep.config.exclude!=undefined){
			$.each(sweep.config.exclude,function(i,item){
				if(item!=undefined)excludeds[item.net_id]=1;
				excludeds_users.push(item);
			});
		}

		var blacklists = [];

		if(window.blacklist!=undefined){
			$.each(window.blacklist, function(i,item){
				blacklists[i]=item;
			});
		}

		//Old winners
		var oldwinners = [];
		$.each(this.state.oldwinners,function(i,item){
			oldwinners.push(item);
		});

		var minDatePicker = sweep.created;
		if(sweep.post_id != null) {
			$.each(sweep.post_id, function(i, item) {
				if(item.created != undefined) {
					//FB,YT,List,IG
					minDatePicker = item.created;
					return false;
				}

				if(item.data != undefined) {
					//TW
					minDatePicker = item.data;
					return false;
				}
			});
		} else {
			minDatePicker = (sweep.config.import_date != undefined) ? sweep.config.import_date : EPDate();
		}

		const date_last_update = EPDateFromNow(sweep.report.last_import_date);
		const date_created = EPDateFromNow(sweep.created);
		
		const has_participants = sweep.config.total_participants > 0;
		const show_manual_update = sweep.status == const_sweep.OPENED &&
									sweep.config.total_participants<=const_sweep.MAX_UPDATE_PARTICIPANTS &&
									(this.is_facebook ||
										this.is_instagram &&
										!this.is_type_hashtag &&
										!this.is_story_mention &&
										!this.is_story_replyto) ||
									this.is_twitter &&
									sweep.config.premium==undefined ? true : false;
		var show_view_and_export = is_twitter_premium || (has_participants && sweep.network != const_sweep.ID_TWITTER && sweep.type != const_sweep.TYPE_FOLLOWER) ? true : false;
		show_view_and_export = vars.total_finalists != undefined && vars.total_finalists==0 ? false : show_view_and_export;

		//Control Payment
		var url_blacklist = window.panel_url + 'blacklist';

		const status_pay = this.state.status;
		switch(sweep.network) {
			case const_sweep.ID_FACEBOOK:
				url_blacklist+='#facebook';
				if(sweep.type!=const_sweep.TYPE_LEAD_ADS){
					url_blacklist+='/'+sweep.page_id;
				}
				break;

			case const_sweep.ID_INSTAGRAM:
				url_blacklist+='#instagram';
				break;

			case const_sweep.ID_TWITTER:
				url_blacklist+='#twitter';
				break;

			case const_sweep.ID_LIST:
				url_blacklist+='#app';
				break;

			case const_sweep.ID_MULTI:
				url_blacklist+='#app';
				break;
		}

		var nav_sections = [];
		nav_sections.push({ label:"Select", link:false });
		nav_sections.push({ label:"Configure", link:false });
		nav_sections.push({ label:"Draw", link:false });
		nav_sections.push({ label:"Publish", link:false });

		const winners_test = this.state.winners_test;
		const alternates_test = this.state.alternates_test;

		const avail_downloads = [
			{ label:i18n("Entrants"), url:window.panel_url+'sweeps/export/'+sweep.id+'?download=true', icon:'knk-users', xls:{enabled:true, utf8:true, iso:true}, csv:{enabled:true, utf8:true, iso:false} },
		];

		const manage_blacklist_actions = (this.props.blacklist_suggestions) ? (
			<span class="gui_link_actions gui_bar_separated in_top">
				<ActionLink onClick={() => this.toggleBlacklistSuggestion()} autotranslate={false}>{i18n("Blacklist candidates", 'lowercase')}</ActionLink>
			</span>
		) : null;

		var display_posts = true;
		switch(parseInt(sweep.type)) {
			case const_sweep.TYPE_FOLLOWER:
			case const_sweep.TYPE_HASHTAG:
			case const_sweep.TYPE_UPLOAD:
			case const_sweep.TYPE_UPLOAD+'_2':
				display_posts = false;
				break;
		}

		const has_blacklist_checkbox = (!this.is_list || (sweep.config.email_field!=undefined && sweep.config.email_field>=0)) ? true : false;

		if(has_blacklist_checkbox && sweep.config.blacklist_flg==undefined){
			sweep.config.blacklist_flg = true;
		}

		var enable_exclusions_rules = true;
		if(this.is_list && (sweep.config.email_field==undefined || sweep.config.email_field < 0)){
			enable_exclusions_rules = false;
		}

		if(this.props.render != undefined && !this.props.render) {
			return null;
		}

		var item_label = {};//for label selector
		item_label.label_id = sweep.label!=undefined ? sweep.label[0].id : '';
		item_label.sweep_id = sweep.id;

		var can_edit_label_selector = true;
		var is_shared_with_me = this.state.sweep.is_shared_with_me != undefined ? this.state.sweep.is_shared_with_me : false;
		if(!this.props.is_agent_admin || is_shared_with_me) {
			const search_labelSelector = this.state.organizers.filter((obj) => { return obj.id == item_label.label_id })[0];
			if(!search_labelSelector) can_edit_label_selector = false;
		}

		let story_giveaway = this.is_instagram && (this.is_story_mention || this.is_story_replyto) ? true : false;
		let monitoring_enabled = false;
		if(sweep.status == const_sweep.OPENED && story_giveaway) {
			monitoring_enabled = true;
			if(sweep.report.monitor_stopped_at != undefined) monitoring_enabled = false;
		}
		
		const type_stories = (this.is_story_mention || this.is_story_replyto) && this.is_instagram ? true : false;

		let tz, end_date, label_status_monitor;
		if(type_stories) {
			tz = sweep.config?.import_timezone || "Europe/Madrid";
			end_date = moment.tz(sweep.created,"Europe/Madrid").add(7, 'days').tz(tz).format(this.date_format + ' LT');
			label_status_monitor = monitoring_enabled ? '' : '<strong class="redColor">['+i18n("Expired").toUpperCase()+']</strong>';
		}

		const disabledAddPrize = this.state.prize_name != '' && this.state.prize_name.length > 1 && parseInt(this.state.prize_qty) > 0 ? false : true;
		const disabledSavePrizes = !this.state.enabled_save_prizes;

		//const display_stats = vars.has_elastic_stats && (!this.is_list && !this.is_type_upload && !this.is_type_prize && !this.is_type_like) ? true : false;
		const link_stats = (vars.has_elastic_stats && !this.is_list && !this.is_type_upload && !this.is_type_prize && !this.is_type_like) ? true : false;

		return (
			<Router hashType="noslash">
				<>	
					<BreadcrumbsNav sections={nav_sections} floating={true} current={this.state.actual_section_id}>
						<HelpFeatureWarning tutorial_url={`${window.zendesk_base_url}360013764092`} />
					</BreadcrumbsNav>

					<Route path="/" exact={true} render={(route) => {
						const main_classes = ['gui_main_owner_header', 'gui_owner_header', 'is_full_layout'];

						let header_ribbons = [];

						header_ribbons.push({
							title:<>{i18n("ID")}: <strong>#{sweep.id}</strong></>,
							autotranslate:false,
							color:'lightgray',
							is_copy:true,
							copy:sweep.id,
							is_html:true,
						});

						if(_size(this.state.organizers) > 0 && sweep.label != undefined) {
							(sweep.label).map((label) => {
								if(can_edit_label_selector) {
									header_ribbons.push({
										title:<>{i18n("Organizing brand")}: <strong>{label.name}</strong></>,
										autotranslate:false,
										color:'lightgray',
										icon:'knk-edit gui_small_icon',
										onClick:() => this.togglePopupTitle(),
										is_html:true,
										tooltip:<Tooltip position="top" with_icon={false}>Click here to add an organizing brand</Tooltip>,
									});
								} else {
									header_ribbons.push({
										title:<>{i18n("Organizing brand")}: <strong>{label.name}</strong></>,
										autotranslate:false,
										color:'lightgray',
										is_html:true,
										tooltip:<Tooltip position="top" with_icon={false}>You can't change the organizing brand</Tooltip>,
									});
								}
							})
						} else if(!is_shared_with_me) {
							header_ribbons.push({
								title:<>{i18n("Organizing brand")}: <strong>{i18n("Not assigned")}</strong></>,
								autotranslate:false,
								color:'main',
								icon:'ep-exclamation gui_small_icon',
								onClick:() => this.togglePopupTitle(),
								is_html:true,
								tooltip:<Tooltip position="top" with_icon={false}>Click here to add an organizing brand</Tooltip>,
							});
						 } else if(sweep.config.company != undefined) {
							header_ribbons.push({
								title:sweep.config.company,
								autotranslate:false,
								color:'lightgray',
								icon:'ep-exclamation gui_small_icon',
								onClick:() => this.togglePopupTitle(),
							});
						}

						if(!show_manual_update) {
							header_ribbons.push({
								title:`${i18n("Created")}: ${date_created}`,
								autotranslate:false,
								color:'lightgray',
								is_html:true,
							});
						}

						return (
							<OwnerPromoWrapper
								{...this.props}
								header={false}
								add_module={false}
								menu={false}
								sidebar={<SweepSidebar
									banners={this.props.banners}
									sweep={sweep}
									post_id={post_id}
									display_posts={display_posts}
									has_basic_subs={this.props.subsbasic}
									has_basicpro_subs={this.props.subspro}
									transferInformationToSweep={(posts, type) => this.transferInformationToSweep(posts, type)}
									type="settings"
								/>}
							>
								<ProfileModule type='header' _class={{other:main_classes.join(" ")}}>
									<ul class="main_contents" style={{ width:'100%' }}>
										<li>
											<div class={`gui_only_wide_screen gui_promo_type_icon medium_icon ${type.icon_class}`} style={{background:vars.color_code}} />
										</li>

										<li style={{flexGrow:'1'}}>
											{(sweep.status == const_sweep.CLOSED || !can_edit_label_selector) ? (
												<h1 class="main_title">{sweep.title}</h1>
											) : (
												<div class="is_editable" onClick={() => this.togglePopupTitle()}>
													<h1 class="main_title editable_content gui_cutTextOnOverflow">{sweep.title}</h1>

													<SquaredButton
														icon='knk-edit'
														_class={{ other:'edit_this' }}
														aria-label="Edit"
													/>
												</div>
											)}

											<RibbonCollection
												items={header_ribbons}
											/>

											<div class="gui_flexbox_auto gui_flex_col">
												<div class="gui_total_participants gui_pos_rel">
													<div>
														<span>{sweep.config.total_participants} {vars.label_participants}</span>

														{(show_view_and_export) && (
															<ButtonCollection style={{ gap:0 }}>
																<ActionLink
																	_class={{other:'gui_in_end'}}
																	onClick={() => this.toggleParticipants()}
																>View</ActionLink>

																{(parseInt(sweep.config.total_participants) <= const_sweep.LIMIT_EXPORT) && (
																	<ActionLink
																		_class={{other:'gui_in_end'}}
																		onClick={() => this.toggleDownloadOptions()}
																	>Export</ActionLink>
																)}

																{link_stats && (
																	<ActionLink
																		_class={{other:'gui_in_end'}}
																		onClick={() => this.displaySweepStats()}
																		autotranslate={false}
																	>
																		{i18n("Statistics", 'lowercase')}

																		{(!this.props.subspro) && (
																			<span class="with_pro_mark">
																				<span class="is_pro_mark">{i18n("PRO")}</span>
																			</span>
																		)}
																	</ActionLink>
																)}
															</ButtonCollection>
														)}
													</div>

													{(show_manual_update) && (
														<span class={`gui_pos_rel not_analyst last_update${((this.state.show_last_update) ? ' is_updatable' : '')}`}>
															<span class="gui_pos_abs">
																<FormattedMessage id="Last update: {date}" values={{date:date_last_update}} />

																{(this.state.show_last_update && !this.is_multi) && (
																	<ActionLink
																		icon='knk-reload'
																		_class={{ other:'whiteColor loading gui_small_icon' }}
																		onClick={() => this.refreshSweep()}
																	>Refresh now</ActionLink>
																)}
															</span>
														</span>
													)}
												</div>

												{(monitoring_enabled) && (
													<div class="monitoring">
														<Spinner _class={{h_position:'left'}}>
															<p>
																<FormattedMessage
																	id="Monitoring {label} from Instagram Business"
																	values={{label:((this.is_story_replyto) ? i18n("Story Replies") : i18n("Story Mentions"))}}
																/>:

																<ActionLink
																	_href={`https://www.instagram.com/${sweep.config.username}`}
																	_target="_blank"
																	_class={{ other:'gui_not_in_start_tiny' }}
																>@{sweep.config?.username ?? "profile"}</ActionLink>
															</p>

															{(sweep.config.import_hashtag != undefined) && (
																<p dangerouslySetInnerHTML={{ __html:this.props.intl.formatMessage({id:"Replies must include the hashtag {hashtag}."}, {hashtag:`<strong>#${(sweep.config.import_hashtag).replace("#", "")}</strong>`})}}></p>
															)}

															<p>
																<span dangerouslySetInnerHTML={{ __html:`${i18n("End date of monitoring")}: <strong>${end_date}</strong> (${tz}) ${label_status_monitor}`}}></span>

																<Tooltip position="top">You can finalize the giveaway before the end date of monitoring. When you finalize it, the monitoring of new entries will stop automatically. Status ACTIVE: System imports new entries. Status EXPIRED: System discards new entries.</Tooltip>
															</p>

															<p class="gui_not_in_top_small">
																<FormattedMessage
																	id="{link} to update the number of participants"
																	values={{link:<ActionLink onClick={() => window.location.reload()}>Reload the page</ActionLink>}}
																/>
															</p>
														</Spinner>
													</div>
												)}
											</div>

											{(this.is_instagram && this.is_type_comment) && (
												<p class="knk-tip gui_small_icon gui_not_in_top_small gui_not_in_bottom_tiny">
													{i18n("See a different number of comments on Instagram?")}

													<ActionLink
														_href={`${window.zendesk_base_url}360015891671`}
														_target="_blank"
														_class={{ other:'gui_not_in_start_small' }}
													>Discover the 4 reasons</ActionLink>
												</p>
											)}
										</li>
									</ul>
								</ProfileModule>

								<MessageFoo
									has_participants={has_participants}
									sweep={sweep}
									intl={this.props.intl}
								/>

								{(monitoring_enabled) && (
									<>
										<Module
											title="Automatic thank you message"
											subtitle="Enable auto-reply message if you want to thank the participants when entering the giveaway. Only will be sent if the user met the participation requirements."
										>
											<Model model={sweep.config} change={(k, v) => this.changeConfig(k, v)}>
												<Checkbox
													name="autoresponder_status"
													label_props={{
														tooltip:<Tooltip>Enable this option if you want to send an automatic reply when the user sends an Instagram message.</Tooltip>,
													}}
												>Enable auto reply message</Checkbox>

												{(sweep.config.autoresponder_status) && (
													<TextArea
														name="autoresponder_comment"
														label_props={{
															tooltip:<Tooltip>Write @username to place the mention</Tooltip>,
														}}
														has_emojis={true}
														max_length={100}
														placeholder={i18n("Thanks for your message")}
													>Reply message</TextArea>
												)}

												{(sweep.config.autoresponder_status) && (
													<AlertMessage
														_class={{ other:'in_bottom' }}
													>
														<p>
															{i18n("Use this message only to thank the participants, confirm their participation and inform them when the winners will be announced. Easypromos is committed to Meta to prevent SPAM on its platform.")+' '}
															<u>{i18n("No links or commercial messages will be accepted.")}</u>
														</p>
													</AlertMessage>
												)}
											</Model>
										</Module>

										{(sweep.status != const_sweep.CLOSED && type_stories && !has_participants) && (
											<ButtonCollection _class={{other:'gui_flex_end is_floating_block gui_is_padded_top_big'}}>
												<SaveButton
													disabled={!this.state.changes_config}
													onClick={(e, cb) => this.save(cb)}
												>Save changes</SaveButton>
											</ButtonCollection>
										)}
									</>
								)}

								{(has_participants) && (
									<>
										{(has_hashtags) && (
											<Module
												title={(this.is_type_comment || this.is_type_hashtag) ? `${i18n("Hashtags detected")} (${hashtags.length})` : `${i18n("Reactions detected")} (${hashtags.length})`}
												autotranslate={false}
												_class={{ other:'not_analyst' }}
											>
												{(this.is_type_comment) && (
													<SectionSubtitle autotranslate={false}>
														{i18n("The platform is able to detect hashtags written by the users in the comments. You can use this feature to set up surveys and polls, as well as limit entrants to the sweepstakes only to those who use a certain hashtag.")} <ActionLink _href={window.zendesk_base_url + ((this.is_instagram) ? '115002111223' : '207885486')} _target="_blank">Learn how to use it and get ideas for your sweepstakes.</ActionLink>
													</SectionSubtitle>
												)}

												<StatsBarsH data={hashtags} total={total_hashtags} />

												{(hashtags.length > 0) && (
													<article class="hashtags_in_use gui_not_in_top">
														{(this.is_type_comment) ? (
															<FieldLabel>(Optional) Limit entrants to only those who use the following hashtags</FieldLabel>
														) : (
															<FieldLabel>Select reactions that you want to send to the draw. If you don't select any, all reactions will be sent</FieldLabel>
														)}

														<ButtonCollection type='ul' _class={{other:'gui_flex_wrap'}}>
															{hashtags.map((hashtag, i) => {
																const name_class = (this.is_type_like) ? 'is_reaction knk-reaction-' + hashtag.name.toLowerCase() : '';

																return (
																	<li key={i}>
																		<ToggleButton
																			active={hashtag?.selected ?? true}
																			color={(hashtag?.selected ?? true) ? 'green' : 'lightgray'}
																			icon={`knk-slide-on ${name_class}`}
																			icon_off={`knk-slide-off ${name_class}`}
																			disabled={disabled}
																			onClick={() => this.saveHashtag(hashtag.name)}
																		>{hashtag.name}</ToggleButton>
																	</li>
																)
															})}
														</ButtonCollection>
													</article>
												)}
											</Module>
										)}

										{(enable_exclusions_rules) && (
											<Module
												title="User exclusion rules"
												tooltip={<Tooltip>Exclude from the sweepstakes users that don't accomplish certain rules</Tooltip>}
												_class={{ other:'not_analyst' }}
											>
												{(this.is_type_comment && !disabled) && (
													<Message>
														<p>{i18n("If a user makes multiple comments on one social network, they will only have one prize draw entry.")}</p>
														{(this.is_multi) && (
															<p><strong>{i18n("If a user comments via multiple social networks, the system will treat each network as a separate entry.")}</strong></p>
														)}
														{(this.is_instagram) && (
															<p><ActionLink _href={window.zendesk_base_url + '115001975283'} _target="_blank">Learn more about exclusion rules for Instagram Sweepstakes</ActionLink></p>
														)}
													</Message>
												)}

												{(this.is_twitter && sweep.type == const_sweep.TYPE_RETWEET && !disabled) && (
													<Message>
														<p><FormattedMessage id="Although the user takes part with several retweets, the user will be entered into the swepstakes with a single entry."/></p>
													</Message>
												)}

												<article class="list_excludes gui_pos_rel">
													<DisabledArea disabled={disabled} message="The sweepstakes is closed">
														<div class="gui_equal_columns gui_padded_children">
															<Model model={sweep.config} change={(k, v) => this.changeConfig(k, v)}>
																<Checkbox
																	name="blacklist_flg"
																	label_props={{
																		extra_contents:(manage_blacklist_actions) ? manage_blacklist_actions : false,
																		_extra_component:<span><ActionLink _href={url_blacklist} _target="_blank">View</ActionLink></span>,
																	}}>Exclude blacklisted users</Checkbox>

																{(!this.is_list) && (
																	<Checkbox
																		name="winners_flg"
																		label_props={{
																			_extra_component:(vars.num_won > 0) ? <ActionLink onClick={()=>this.toggleOldWinners()}>View</ActionLink> : null,
																		}}
																	>Exclude previous winners</Checkbox>
																)}

																{(sweep.config.winners_flg && show_fb) && (
																	<Message
																		_class={{ other:'gui_not_in_top_tiny' }}
																	>
																		<p>{i18n("Winners of Facebook giveaways from before January 8, 2019, will not be taken into account for this exclusion.")}</p><p><ActionLink _href="https://status.easypromosapp.com/status/incident/id/b40aa432-bceb-11e8-9a64-000c29cdc144-03c4d512-1977-11e9-a364-000c29960262" _target="_blank">Why?</ActionLink></p>
																	</Message>
																)}

																{(this.is_twitter && sweep.type != const_sweep.TYPE_FOLLOWER) && (
																	<Checkbox
																		name="nofollowers_flg"
																	>Exclude Non-Followers</Checkbox>
																)}

																{((this.is_type_comment || this.is_story_replyto) && has_hashtags) && (
																	<Checkbox
																		name="multiple_hashtags_flg"
																	>Exclude users with more than one hashtag</Checkbox>
																)}

																{(show_multiple_post) && (
																	<Select
																		_class={{width:50}}
																		name="multiple_post"
																		values={array_multiple_post}
																		label_props={{
																			tooltip:<Tooltip>The minimum number of posts a user has to comment on to enter the draw.</Tooltip>,
																		}}
																	>Minimum number of commented posts</Select>
																)}

																{(this.is_type_comment || this.is_story_replyto) && (
																	<Select
																		_class={{width:50}}
																		name="num_characters"
																		values={num_characters}
																		label_props={{
																			tooltip:<Tooltip>A comment with a greater number of characters implies more quality of the participation. About 50 characters are approx. 7 words.</Tooltip>,
																		}}
																	>Min. number of characters in comments</Select>
																)}
															</Model>

															<div>
																{(this.is_instagram || ((this.is_multi || this.is_twitter) && this.props.subspro)) && (
																	<div>
																		{(this.is_instagram) && (
																			<Message
																				title="Why can't I exclude non-followers?"
																			>
																				<p>{i18n("Since April 4, 2018, Instagram doesn't allow apps to filter by users relationship.")} <ActionLink _href={`${window.zendesk_base_url}360000511003`} _target="_blank">Read the post</ActionLink></p>
																			</Message>
																		)}

																		<Model model={sweep.config} change={(k, v) => this.changeConfig(k, v)}>
																			{((this.is_type_comment || this.is_story_replyto || this.is_type_hashtag) && !show_fb) && (
																				<Select name="num_mentions" values={num_mentions}>Comments must include a minimum number of mentions</Select>
																			)}

																			{(sweep.type != const_sweep.TYPE_FOLLOWER && this.is_twitter) && (
																				<Input name="num_followers">Minimum number of followers</Input>
																			)}
																		</Model>
																	</div>
																)}

																{(this.is_type_comment || sweep.type == const_sweep.TYPE_RETWEET || this.is_type_hashtag) && (
																	<div>
																		<Checkbox
																			name="time_block_flg"
																			model={sweep.config}
																			change={(k, v) => this.changeConfig(k, v)}
																			autotranslate={false}
																		>{i18n("Exclude entries registered after")}...</Checkbox>

																		<div class="gui_pos_rel">
																			<DisabledArea disabled={(sweep.config.time_block_flg != '1') ? true : false}>
																				<Model classname="time_options" model={sweep.config} change={(k, v) => this.changeConfig(k, v)}>
																					<Select
																						_class={{size:50}}
																						name="time_block_timezone"
																						value = {sweep?.config?.time_block_timezone ?? this.time_block_timezone}
																						values={timezones}
																					>Time zone</Select>

																					<DateTimePicker
																						_class={{size:50}}
																						name="time_block_time"
																						value={this.time_block_time}
																						min_date={EPDate(minDatePicker)}
																					>Datetime</DateTimePicker>
																				</Model>
																			</DisabledArea>
																		</div>
																	</div>
																)}

																<div class="gui_asided_options_area not_in_top">
																	<Autocomplete
																		suggestId='data'
																		fetch={(v, cb) => this.fetchFinalists(v, cb)}
																		autoclear={true}
																		placeholder="Type users to exclude"
																		_class={{first:true}}
																		selected={(c) => this.exclude(c.suggestion.data, 'add')}
																		after_component={ (show_view_and_export) ? <ActionLink _class={{other:'gui_in_end'}} onClick={() => this.toggleParticipants()}>Select from the entrants list</ActionLink> : null}
																	>Type users to exclude</Autocomplete>

																	{(excludeds_users != undefined && _.size(excludeds_users) > 0) && (
																		<ul class="gui_sortable_list gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap not_in_top gui_overflowed_auto" style={{maxHeight:'165px'}}>
																			{excludeds_users.map((excluded, i) => {
																				if(excluded.name == undefined || excluded.name == '') return null;

																				return (
																					<li key={'excl'+i} class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
																						<div class="item_header" style={{paddingLeft:'10px'}}>
																							<div class="item_title_container" style={{maxWidth:'100%'}}>
																								<strong>{excluded.name}</strong>
																							</div>

																							<ButtonCollection>
																								<SquaredButton
																									tooltip={<Tooltip position="top" with_icon={false}>Add to blacklist</Tooltip>}
																									onClick={() => this.blacklist(excluded, 'add')}
																									icon='knk-blacklist'
																									aria-label="Add to blacklist"
																								/>

																								<SquaredButton
																									tooltip={<Tooltip position="top" with_icon={false}>Include again to sweep</Tooltip>}
																									onClick={() => this.exclude(excluded)}
																									color="red"
																									icon='knk-drop'
																									aria-label="Remove from blacklist"
																								/>
																							</ButtonCollection>
																						</div>
																					</li>
																				)
																			})}
																		</ul>
																	)}
																</div>
															</div>
														</div>
													</DisabledArea>
												</article>
											</Module>
										)}

										<Module
											title="Number of winners and alternates"
											subtitle={<FormattedMessage id="The total amount of winners and alternates must be less than {max_winners}." values={{max_winners:'1,000'}} />}
											tooltip={<Tooltip>Indicate the number of winners and alternates you want to obtain automatically.</Tooltip>}
										>
											<div class="gui_pos_rel">
												<DisabledArea disabled={disabled} message="The sweepstakes is closed">
													<div class="gui_equal_columns gui_padded_children">
														{(sweep.config.prizes != undefined && _.size(sweep.config.prizes) > 0) ? (
															<div class="gui_pos_rel" onClick={() => this.setState({ display_prizes_layer:true })}>
																<Input
																	name="num_winners"
																	_type="number"
																	min="1"
																	max="1000"
																	disabled={true}
																	label_props={{
																		extra_contents_whole:false,
																		_extra_component:<ActionLink >customize prizes</ActionLink>,
																	}}
																	model={sweep.config}
																>Number of winners</Input>

																<Tooltip position='bottom' with_icon={false}>Click to manage prizes</Tooltip>
															</div>
														) : (
															<Input
																name="num_winners"
																_type="number"
																min="1"
																max="1000"
																label_props={{
																	extra_contents_whole:false,
																	_extra_component:<ActionLink onClick={() => this.setState({ display_prizes_layer:true })}>customize prizes</ActionLink>,
																}}
																model={sweep.config}
																change={(k, v) => this.changeConfig(k, v)}
															>Number of winners</Input>
														)}

														<Input
															name="num_substitutes"
															_type="number"
															min="0"
															max="999"
															label_props={{
																extra_contents_whole:false,
																addition:{
																	text: this.is_list ? "Recommendation: minimum 1." : "Minimum 1",
																	link_text:"Why?",
																	link_url:window.zendesk_base_url + '214255606',
																}
															}}
															model={this.state.sweep.config}
															change={(k, v) => this.changeConfig(k, v)}
														>Number of alternate winners</Input>
													</div>
												</DisabledArea>
											</div>
										</Module>

										{(this.state.display_alternates_alert_layer) && (
											<FloatingLayer _class={{ size:'small' }} backButton={() => this.setState({ display_alternates_alert_layer:false })}>
												<div>
													<SectionTitle>You haven't requested any alternate winner.</SectionTitle>

													<SectionSubtitle>We recommend requesting at least 1 alternate.</SectionSubtitle>

													<SectionSubtitle>Are you sure you want to continue?</SectionSubtitle>

													<ButtonCollection in_floating={true}>
														<MainButton
															onClick={(e, cb) => this.gotoConfirm(false, cb)}
														>Continue</MainButton>

														<SecondaryButton
															onClick={() => this.setState({ display_alternates_alert_layer:false })}
														>Cancel</SecondaryButton>
													</ButtonCollection>
												</div>
											</FloatingLayer>
										)}
																		
										{(sweep.status != const_sweep.CLOSED) && (
											((status_pay.pay_subscription!= undefined && status_pay.pay_subscription > 0 && !this.state.outlimited) || status_pay.free) ? (
												(!status_pay.free) ? (
													<section class="gui_is_padded_hi main_bg">
														<SectionTitle>Choose a plan to continue</SectionTitle>

														<SectionSubtitle autotranslate={false}>{i18n("To select the winners and get a Certificate of Validity, you must have an active plan.") + ' ' + i18n("You can sign up for any plan for just one month.")}</SectionSubtitle>

														{(status_pay.free_status == 'page') && (
															<SectionSubtitle autotranslate={false}><FormattedMessage id="It is not the first giveaway for this {network} account." values={{network:this.props.type.name}}/></SectionSubtitle>
														)}

														{(status_pay.pay_subscription > 0) && (
															<RadioGroup
																elements={this.state.options_payment}
																name="need_subscription"
																model={this.state}
																change={(k, v) => this.changeState(k, v)}
																autotranslate={false}
															/>
														)}

														{(status_pay.pay_subscription >= 2 && !is_giveaway_list) && ( //If not Basic Simple, not show
															<BasicPlansComparisonTable
																label="Compare the two plans"
																_class={{other:'not_in_top not_in_start'}}
															/>
														)}
													</section>
												) : (
													(!this.props.subsbasic && !this.props.subspro) && (
														<section class="gui_is_padded main_bg">
															<SectionTitle autotranslate={false} _class={{icon:'knk-check', other:'gui_not_in_start greenColor not_in_bottom'}}>
																<FormattedMessage id="Your first {network} Giveaway with Easypromos is free." values={{network:this.props.type.name}} />

																<p class="main_text_color" style={{fontSize:'0.8em'}}>
																	<FormattedMessage id="Click {button} when the entry period is over and you need to pick the winners of the giveaway." values={{button:'"' + i18n("Continue") + '"'}} />
																</p>
															</SectionTitle>
														</section>
													)
												)
											) : (
												(this.state.outlimited) && (
													<section class="gui_is_padded main_bg">
														<AlertMessage
															title="Giveaway not available"
														>
															<p>
																<FormattedMessage id="The giveaway has more than {limit} participants" values={{limit:this.state.outlimited}} />
															</p>
														</AlertMessage>
													</section>
												)
											)
										)}

										{(sweep.status != const_sweep.CLOSED) && (
											<ButtonCollection _class={{other:'gui_flex_end is_floating_block gui_is_padded_top_big'}}>
												<SaveButton
													disabled={!this.state.changes_config}
													onClick={(e, cb) => this.save(cb)}
												>Save changes</SaveButton>

												<SaveButton
													onClick={(e, cb) => this.gotoConfirm(false, cb)}
												>Continue</SaveButton>
											</ButtonCollection>
										)}
									</>
								)}
							</OwnerPromoWrapper>
						)
					}} />

					<Route path="/confirm" exact={true} render={(route) => {
						if(sweep.status == "1") window.location.href = getRemotedbUrl(`${window.panel_url}sweeps/success/${sweep.id}`);

						const has_test = status_pay.free && !this.props.subsbasic ? false : true;
						return (
							<OwnerPromoWrapper
								{...this.props}
								header={false}
								add_module={false}
								menu={false}
								sidebar={<SweepSidebar
									banners={this.props.banners}
									sweep={sweep}
									post_id={post_id}
									display_posts={display_posts}
									has_basic_subs={this.props.subsbasic}
									has_basicpro_subs={this.props.subspro}
									transferInformationToSweep={(posts, type) => this.transferInformationToSweep(posts, type)}
									type="settings"
								/>}
							>
								<MessageFoo
									has_participants={has_participants}
									sweep={sweep}
									intl={this.props.intl}
								/>

								<Module
									title={i18n("Pick your winners - Final step")}
									subtitle={<><strong>{i18n("Congratulations, you are one step away from obtaining the winners of the sweepstakes.")}</strong><br />{i18n("Upon selecting the winners a certificate of validity will be issued including the following information: date and time of the sweepstakes, reference and list of winners and alternates. Once issued, this certificate cannot be eliminated.")}</>}
									autotranslate={false}
									actions={!this.state.in_draw ? <BackButton
										onClick={() => this.backConfirm()}
									/>: null}
								>
									<AlertMessage
										title="Important note"
									>
										<p>{i18n("The result of the sweepstakes and the corresponding certificate of validity can't be removed, and they'll be public and accessible to any user.")}</p>

										<p>{i18n("The issued certificate will be published immediately on this website")}: <ActionLink _href={window.ep_sweeps_url+'certificates'} _target="_blank">{window.ep_sweeps_url+'certificates'}</ActionLink></p>
									</AlertMessage>

									<Message
										title="What can you do now?"
										_class={{ other:'in_bottom' }}
									>
										<p><strong><FormattedMessage id="{label} button" values={{label:'"'+i18n("Ready! Pick the winners")+'"'}}/></strong>: {i18n("The sweepstakes will be carried out randomly, the certificate of validity will be issued, and you will be taken to the screen to set up the winner's publication. Once the sweepstakes has been made it cannot be repeated. You will be asked a new confirmation.")}</p>
										{has_test && (
											<p><strong><FormattedMessage id="{label} button" values={{label:'"'+i18n("Test it!")+'"'}}/></strong>: {i18n("Make test of the giveaway and some winners and alternate winners among your finalists will be displayed. The result will not be published, not will a certificate of validity be issued. It is not a valid giveaway, and you can run as many tests as you wish.")}</p>
										)}
										<p><strong><FormattedMessage id="{label} button" values={{label:'"'+i18n("Go back")+'"'}}/></strong>: {i18n("Go back to the previous screen to set up the sweepstakes.")}</p>
									</Message>

									<ButtonCollection _class={{other:'gui_not_in_top'}}>
										{(has_test) && (
											<SaveButton
												disabled={this.state.in_draw}
												onClick={(e, cb) => this.doSweep(1, 0, cb)}
												secondary={true}
											>Test it!</SaveButton>
										)}

										<MainButton
											disabled={this.state.in_draw}
											onClick={(test) => this.toggleCertificates()}
										>Ready! Pick the winners</MainButton>

										{(this.state.in_draw == 'test') && (
											<span>{`🔧 ${i18n("Test giveaway in progress")}... ${i18n("Please wait for the results!")}`}</span>
										)}

									</ButtonCollection>
								</Module>
							</OwnerPromoWrapper>
						)
					}} />

					{(this.state.display_prizes_layer) && (
						<FloatingLayer backButton={() => this.setState({ display_prizes_layer:false })}>
							<div>
								<SectionTitle>Add different prizes for your winners</SectionTitle>

								<SectionSubtitle>Prizes will be given to the winners in the same order they are drawn.</SectionSubtitle>

								<div class="gui_equal_columns gui_padded_children">
									<div class="gui_flexbox_auto gui_flex_col gui_flex_nowrap">
										<Model model={this.state} change={(k, v) => this.changeState(k, v)}>
											<Input
												name="prize_name"
												_class={{first:true}}
												max_length="30"
												placeholder="Marvelous prize"
												label_props={{
													extra_contents:i18n("Written in singular"),
												}}
											>Prize Name</Input>

											<Input
												name="prize_qty"
												_type="number"
												min="1"
												max="1000"
												_class={{size:30}}
												placeholder="1"
											>Quantity</Input>
										</Model>

										<ButtonCollection _class={{other:'not_in_top gui_flex_end'}}>
											<MainButton
												disabled={disabledAddPrize}
												onClick={() => this.createPrize()}
											>Add prize</MainButton>
										</ButtonCollection>
									</div>

									<div class="gui_not_in_bottom">
										{(_.size(sweep.config.prizes) > 0) && (
											<ul>
												{sweep.config.prizes.map((prize, i) => {
													return (
														<li key={'prize_'+i} class="gui_flexbox_auto gui_flex_nowrap gui_padded_children_low gui_not_in_bottom_tiny gui_not_padded_in_bottom_tiny gui_bordered_bottom">
															<div class="gui_flexbox gui_flex_nowrap gui_pos_rel gui_flex_align_center" style={{flexGrow:'1'}}>
																<div class="gui_cutTextOnOverflow">{prize.qty} × <strong>{prize.name}</strong></div>
															</div>

															<ButtonCollection>
																<DeleteButton
																	squared={true}
																	onClick={() => this.removePrize(i)}
																/>
															</ButtonCollection>
														</li>
													)
												})}
											</ul>
										)}

										<div class="gui_flexbox_auto gui_flex_nowrap gui_padded_children_low gui_not_in_top" style={{padding:'8px', background:'rgba(0, 0, 0, 0.1)'}}>
											<div class="gui_flexbox gui_flex_nowrap" style={{flexGrow:'1'}}>
												<div class="gui_flexbox_auto gui_flex_align_center" style={{lineHeight:'1em'}}>{i18n("Total winners")}:&nbsp;<strong>{sweep.config.num_winners}</strong></div>
											</div>
										</div>
									</div>
								</div>

								<ButtonCollection in_floating={true}>
									<SaveButton
										disabled={disabledSavePrizes}
										onClick={(e,cb) => this.closeAndSavePrizes(cb)}
										color={disabledSavePrizes ? "gray" : "green"}
									>Save</SaveButton>
								</ButtonCollection>
							</div>
						</FloatingLayer>
					)}

					{(this.state.display_popup_title) && (
						<FloatingLayer backButton={() => this.togglePopupTitle()} _class={{size:'small'}}>
							<div>
								<SectionTitle>Edit giveaway data</SectionTitle>

								<TextArea
									_class={{first:true}}
									name="title"
									model={this.state.sweep}
									change={this.change.bind(this)}
								>Title</TextArea>

								<div class="gui_not_in_top">
									<FieldLabel>Organizer</FieldLabel>

									<LabelSelector
										callback_set_label={this.setLabelSweep.bind(this)}
										display_on='inline'
										type="3"
										organizers={this.state.organizers}
										item_to_assign={item_label}
										is_agent_admin={this.props.is_agent_admin}
									/>
								</div>

								<ButtonCollection in_floating={true}>
									<SaveButton
										icon='knk-on'
										onClick={(e, cb) => this.save(cb)}
									>Save changes</SaveButton>
								</ButtonCollection>
							</div>
						</FloatingLayer>
					)}

					{(this.state.display_download_options) && (
						<DownloadFileOptions downloads={avail_downloads} close={()=> this.toggleDownloadOptions()}/>
					)}

					{(this.state.display_oldwinners) && (
						<FloatingLayer backButton={() => this.toggleOldWinners()} _class={{size:'fullscreen'}}>
							<div class="without_actions">
								<SectionTitle>List of previous winners</SectionTitle>
								<div class="turn_to_landscape only_in_portrait max_width_500">
									<div class="knk-landscape-mode">
										<SectionSubtitle autotranslate={false}>{i18n("This content doesn't fit in portrait mode.")} {i18n("Please, turn your device to landscape mode.")}</SectionSubtitle>
									</div>
								</div>

								{_size(oldwinners)>0 ? (
									<InfiniteScroll fetch={(p, cb) => this.fetchOldWinners(p,cb)} fetched={this.fetched2.bind(this)} _maxHeight={{maxHeight:'calc(100dvh - 185px)'}}>
										<table class="only_in_landscape max_width_500 gui_list_table gui_huge_dom_content" style={{width:'100%'}} cellSpacing="0" cellPadding="0">
											<thead>
												<tr class="list_header">
													<th />
													<th>{i18n("***Name")}</th>
													<th>{i18n("Giveaway")}</th>
													<th>{i18n("Created")}</th>
													<th />
												</tr>
											</thead>
											<tbody>
												{oldwinners.map((participant, i) => {
													var link = (participant.link_to_post != undefined) ? participant.link_to_post : false;
													return (
														<tr key={i}>
															<td>{i+1}</td>
															<td class="name">
																<div class="gui_flexbox gui_flex_row gui_flex_nowrap gui_flex_align_center">
																	{(this.is_multi) && (
																		<SquaredButton
																			color="black"
																			icon={`ep-${participant.network}`}
																			_class={{other:'gui_withoutEvents'}}
																			aria-label="Participant network"
																		/>
																	)}

																	<UserName
																		linked={link}
																		link={link}
																		user={participant}
																		is_builder={true}
																	/>
																</div>
															</td>
															<td>{participant.sweep_name}</td>
															<td>{participant.created}</td>
															<td><ActionLink _href={participant.link} _target="_blank" _class={{icon:'knk-winners'}}>View sweepstakes</ActionLink></td>
														</tr>
													)
												})}
											</tbody>
										</table>
									</InfiniteScroll>
								) : (
									<tbody><tr><td colSpan="5">{i18n("There are no previous winners")}</td></tr></tbody>
								)}
							</div>
						</FloatingLayer>
					)}

					{(this.state.display_check_certificate) && (
						<FloatingLayer backButton={() => this.toggleConfirm()} _class={{size:'small'}} enable_close={false}>
							<div>
								{(this.state.in_draw == 'real') && (
									<Spinner 
										is_transparent={false}
										force_bg={true}
										autotranslate={false}
										color="var(--ep-black-color)"
										><p>{`🎲 ${i18n("Giveaway in progress")}`}</p><p>{i18n("Please wait for the results!")}</p>
										{(parseInt(this.state.in_draw_counter.total) > 50000) && (
											<ButtonCollection in_floating={true}>
												<p style={{flexShrink:0, paddingRight:'20px'}}>🎉 {i18n("Participants in giveaway")}: <strong>{this.state.in_draw_counter.partial}</strong></p>
												<ProgressBar
													actual={(this.state.in_draw_counter.partial)}
													max={this.state.in_draw_counter.total}
													size='big'
												/>

											</ButtonCollection>
										)}
										</Spinner>
								) }

								<Message
									icon={false}
									_class={{ other:'in_top' }}>
									<p>{i18n("The system will select randomly")}:</p>
									<div>
										<ul class="bulleted_list">
											<li><strong>{sweep.config.num_winners} {i18n((sweep.config.num_winners > 1) ? "Winners" : "Winner", 'lowercase')}</strong></li>

											{(sweep.config.num_substitutes > 0) && (
												<li><strong>{sweep.config.num_substitutes} {i18n((sweep.config.num_substitutes > 1) ? "Alternates" : "Alternate", 'lowercase')}</strong></li>
											)}
										</ul>
									</div>
								</Message>

								<Checkbox
									name="accept_live_mode"
									_class={{first:true}}
									model={this.state}
									change={(k, v) => this.changeState(k, v)}
									label_props={{
										extra_contents_whole:true,
										extra_contents:<span class="gui_not_in_top_tiny">[<ActionLink _href={`https://www.youtube.com/watch?v=${window.is_spanish ? '0EI_MYd7kk0' : 'Xo0gGIkmSVE'}`} _target="_blank">View example</ActionLink>]</span>,
									}}
								>View the random draw as an animated presentation</Checkbox>

								<Checkbox
									name="accept_certificate"
									model={this.state}
									change={(k, v) => this.changeState(k, v)}
									label_props={{
										extra_contents_whole:true,
										extra_contents:<span class="gui_not_in_top_tiny">[<FormattedMessage id="It will be published {link_certificate}" values={{link_certificate:<ActionLink _href={window.ep_sweeps_url+'certificates'} _target="_blank">here</ActionLink>}} />]</span>,
									}}
								>I understand and agree that a public certificate will be generated with the result of the draw and I can not repeat it.</Checkbox>

								<ButtonCollection in_floating={true}>
									<SaveButton
										disabled={!this.state.accept_certificate}
										onClick={(e, cb) => this.doSweep(0,this.state.accept_live_mode?1:0, cb)}
										icon='knk-on'
									>Continue</SaveButton>

									<SecondaryButton
										disabled={this.state.in_draw}
										onClick={() => this.toggleCertificates()}
									>Cancel</SecondaryButton>
									
								</ButtonCollection>
							</div>
						</FloatingLayer>
					)}

					{(this.state.display_participants) && (
						<SweepParticipantsLayer
							roles={this.props.roles}
							limit_show={!this.props.subspro ? const_sweep.LIMIT_SUBSCRIPTION_PRO : const_sweep.LIMIT_INFINITE}
							back={this.toggleParticipants.bind(this)}
							toggleDownloadOptions={this.toggleDownloadOptions.bind(this)}
							participants_photo={this.state.participants_photo}
							stateStatus={(e, r) => this.stateStatus(r)}
							sweep={this.state.sweep}
							participants={this.state.participants}
							save={this.save.bind(this)}
						/>
					)}

					{(this.state.display_blacklist_suggestions) && (
						<SweepBlacklistSuggestLayer
							back={this.toggleBlacklistSuggestion.bind(this)}
							sweep={this.state.sweep}
							suggestions={this.state.suggestions}
						/>
					)}

					{(this.state.display_refresh_post) && (
						<FloatingLayer _class={{size:'small'}} enable_close={false}>
							{(this.state.post_on_refresh) ? (
								<div>
									<div class="gui_not_padded_in_bottom" style={{borderBottom:'1px solid rgba(0, 0, 0, 0.2)', marginBottom:'20px'}}>
										<div class="gui_overflowed_auto" style={{maxHeight:'105px',height:'105px'}}>
											<SectionTitle autotranslate={false}>{(this.state.post_on_refresh) && (this.state.post_on_refresh.text)}</SectionTitle>
										</div>
									</div>
									<div class="gui_pos_rel gui_not_in_top">
										<Spinner>Retrieving new participants</Spinner>
									</div>

									<ButtonCollection in_floating={true}>
										<p style={{flexShrink:0, paddingRight:'20px'}}>{i18n("Total imported")}: <strong>{this.state.refresh_participants}</strong></p>

										<ProgressBar
											actual={(this.state.fetching_selected_id + 1)}
											max={_size(sweep.post_id)}
										/>
									</ButtonCollection>
								</div>
							) : (
								<div>
									<div class="gui_pos_rel gui_text_align_center gui_not_in_top">
										<Spinner autotranslate={false}>{(this.is_twitter && sweep.type == const_sweep.TYPE_FOLLOWER) ? i18n("Getting new followers, please wait") : i18n("Loading posts, please wait")}</Spinner>
									</div>
								</div>
							)}
						</FloatingLayer>
					)}

					{(this.state.display_error_export) && (
						<FloatingLayer _class={{size:'small'}} backButton={() => this.closeLayerErrors()}>
							{(this.state.sweep.config.total_participants > const_sweep.LIMIT_SUBSCRIPTION_PRO && !this.props.subspro) ? (
								<div class="without_actions">
									<SectionTitle _class={{in_top:true}} autotranslate={false}><FormattedMessage id="Exporting all participants to an Excel file is only available to clients with an active {plan}." values={{plan:i18n("Basic PRO Plan")}}/></SectionTitle>
									<p>
										<FormattedMessage id="{label_basic}, and download the full Excel file with all participants." values={{label_basic:<ActionLink _gaEvent={this.event_export} _href={window.panel_url+const_sweep.subscription_link_pro +'?exportxls'} autotranslate={false}>{i18n("Activate now a Basic PRO plan for")+' '+this.props.pricepro }</ActionLink>}}/>
									</p>
								</div>
							) : (
								<div class="without_actions">
									<SectionTitle _class={{in_top:true}} autotranslate={false}><FormattedMessage id="Exporting all participants to an Excel file is only available to clients with an active {plan}." values={{plan:i18n("Basic Plan")}}/></SectionTitle>
									<p>	
										<FormattedMessage id="{label_basic}, and download the full Excel file with all participants." values={{label_basic:<ActionLink _gaEvent={this.event_export} _href={window.panel_url+const_sweep.subscription_link_basic+'?exportxls'} autotranslate={false}>{i18n("Activate now a Basic plan for")+' '+this.props.pricebasic}</ActionLink>}}/>
									</p>
								</div>
							)}
						</FloatingLayer>
					)}

					{(this.state.display_error_connect) && (
						<FloatingLayer _class={{size:'small'}} backButton={() => this.closeErrorConnect()}>
							{(this.state.display_error_connect_exception == 'token') && (
								<div>
									<SectionTitle _class={{icon:'knk-alert',other:'redIcon'}}>Could not connect to Facebook in order to update the participants.</SectionTitle>
									<SectionSubtitle>Please, make sure that you are connected on Facebook as a user administrator of the Facebook page and try it again.</SectionSubtitle>
									<ButtonCollection in_floating={true}>
										{(!this.state.rerequest) ? (
											<SaveButton
												icon={`ep-${sweep.network}`}
												onClick={(e,cb) => this.rerequest(sweep.network,cb)}
											>Connect to Facebook</SaveButton>
										) : (
											<SaveButton
												icon={`ep-${sweep.network}`}
												onClick={(e,cb) => this.rerequest_login(sweep.network,()=>this.refreshSweep())}
											>Ready! Click here to grant access now.</SaveButton>
										)}
									</ButtonCollection>
								</div>
							)}

							{(this.state.display_error_connect_exception == 'missed' || this.state.display_error_connect_exception == '') && (
								<div class="without_actions">
									<SectionTitle autotranslate={false} _class={{icon:'knk-alert',other:'redIcon'}}><FormattedMessage id="Your post on {network} has not been found" values={{network:i18n(network,'c')}}/></SectionTitle>
									<SectionSubtitle autotranslate={false}>{i18n("If you deleted the post from your Facebook page, the sweepstakes can not be done.")+' '+i18n("What do you want to do?")}</SectionSubtitle>
									<ul>
										<li class="not_block">
											<ActionLink onClick={() => this.failurePost('new')}>Delete this sweepstakes and start over</ActionLink>
										</li>
									</ul>
								</div>
							)}
						</FloatingLayer>
					)}

					{(this.state.display_test_winners) && (
						<FloatingLayer _class={{size:'normal'}} backButton={() => this.closeTestLayer()}>
							<div class="without_actions">
								<SectionTitle>Sweepstakes Test Results</SectionTitle>

								<Message
									title="This is a test"
									icon='knk-alert'
									_class={{ other:'in_top' }}
								>
									<p>{i18n("This result is not valid and the certificate of validity has not been issued")}</p>
								</Message>

								<article class="gui_flex_columned gui_flexbox gui_flex_nowrap gui_flex_row gui_flex_start gui_flex_space_between">
									<article class="this_section gui_hidden_overflowed visibly_disabled">
										<h3 class="list_title ep-winners">{i18n("Winners")} ({winners_test.length})</h3>

										<div class="gui_overflowed_content not_borderered" style={{maxHeight:'40svh'}}>
											<div class="gui_pos_rel" style={{minHeight:'100px'}}>
												<ul class={'gui_list is_winners' + ((this.is_list) ? ' not_linkable' : '')}>
													{winners_test.map((winner, i) => {
														var prize = false;
														if(sweep.config.prizes!=undefined && _.size(sweep.config.prizes)>0){
															prize = this.getPrize(i);
														}

														return (
															<li key={i} class="gui_pos_rel" style={(prize) ? {paddingTop:'5px', paddingBottom:'5px'} : null}>
																<span class="index">#{i+1}</span>
																{(this.is_multi) && (
																	<span class={'ep-'+winner.network + ' main_text_color_icon gui_is_not_padded'} style={{flexBasis:'auto'}}></span>
																)}

																<div class="gui_flexbox_auto gui_flex_col gui_flex_nowrap user_with_prize" style={{flexGrow:1}}>
																	<UserName linked={false} user={winner} />
																	{(prize) && (
																		<span class="gui_ribbons"><span class="ribbon in_top gui_not_in_bottom_tiny">{prize}</span></span>
																	)}
																</div>
															</li>
														)}
													)}
												</ul>
											</div>
										</div>
										<span class="gui_is_demo_msg" style={{transform:'rotate(' + this.state.test_advise + ')'}}>{i18n("This is a test")}. {i18n("Sweepstakes not valid")}</span>
									</article>

									{(alternates_test.length > 0) && (
										<article class="this_section gui_hidden_overflowed visibly_disabled">
											<h3 class="list_title knk-winners grayIcon">{i18n("Alternates")} ({alternates_test.length})</h3>

											<div class="gui_overflowed_content not_borderered" style={{maxHeight:'40svh'}}>
												<div class="gui_pos_rel" style={{minHeight:'100px'}}>
													<ul class={'gui_list is_alternates' + ((this.is_list) ? ' not_linkable' : '')}>
														{alternates_test.map((alternate, i) => {
															return (
																<li key={i}>
																	<span class="index">#{i+1}</span>

																	{(this.is_multi) && (
																		<SquaredButton
																			color='black'
																			icon={`ep-${alternate.network}`}
																			_class={{ other:'gui_withoutEvents' }}
																			aria-label="Participant network"
																		/>
																	)}

																	<UserName linked={false} user={alternate} />
																</li>
															)}
														)}
													</ul>
												</div>
											</div>
											<span class="gui_is_demo_msg" style={{transform:'rotate(' + this.state.test_advise + ')'}}>{i18n("This is a test")}. {i18n("Sweepstakes not valid")}</span>
										</article>
									)}
								</article>
							</div>
						</FloatingLayer>
					)}

					{(this.state.display_refresh_manual) && (
						<FloatingLayer _class={{size:'small'}} backButton={() => this.toggleRefreshManual()}>
							<div>
								<SectionTitle>Important note</SectionTitle>

								<Message
									_class={{ other:'in_top' }}
								>
									<div>
										<ul class="bulleted_list">
											{(story_giveaway) ? (
												<>
													<li><FormattedMessage id="The last participant has been added {date}" values={{date:<strong>{date_last_update}</strong>}} /></li>

													{(monitoring_enabled) && (
														<li><FormattedMessage id="The monitor will stop automatically after the end of the giveaway"/></li>
													)}
												</>
											) : (
												<li><FormattedMessage id="You updated participants {date}." values={{date:<strong>{date_last_update}</strong>}} /></li>
											)}

											<li><FormattedMessage id="Your currently number of participants is: {num}." values={{num:<strong>{sweep.config.total_participants}</strong>}} /></li>
										</ul>
									</div>
								</Message>

								{(!story_giveaway) && (
									<p>{i18n("To check if more have joined, click refresh")}.</p>
								)}

								<ButtonCollection in_floating={true}>
									<SaveButton
										onClick={(e, cb) => this.gotoConfirm(true, cb)}
									>Continue</SaveButton>

									{(!story_giveaway) && (
										<SaveButton
											icon='knk-reload'
											color='red'
											onClick={() => this.refreshSweep()}
										>Refresh now</SaveButton>
									)}
								</ButtonCollection>
							</div>
						</FloatingLayer>
					)}
					
					{(this.state.display_stats) && (
						<SweepElasticStats sweep={sweep} subspro={this.props.subspro} intl={this.props.intl} close={()=>this.setState({display_stats:false})}/>
					)}					
					{(this.state.display_save_message) && (
						<SaveResponseMessage
							status={this.state.display_save_status}
							message={<span dangerouslySetInnerHTML={{ __html:this.state.display_save_message}} />}
						/>
					)}					
				</>
			</Router>
		);
	}
}

export default injectIntl(SweepSettings);